import axios from 'axios';
import Cookies from 'js-cookie';
import {CONFIG} from '../config';

axios.defaults.withCredentials = true;
export default axios.create({
    baseURL: CONFIG.CBT_MANAGEMENT_HOST,
    headers: {
        'Accept':  'application/json',
        'Content-Type': 'application/json',
        'Cache': 'no-cache',
        Cookie: Cookies.get('Set-Cookie')
    }
});